import type { DirectiveBinding, ObjectDirective } from 'vue';

interface RevealEl extends HTMLElement {
  _homeRevealIo?: IntersectionObserver;
}

function revealDelay(binding: DirectiveBinding): string | null {
  if (typeof binding.value === 'number') return `${binding.value}ms`;
  if (typeof binding.value === 'string') return binding.value;
  if (binding.value && typeof binding.value === 'object' && 'delay' in binding.value) {
    const delay = (binding.value as { delay: number | string }).delay;
    return typeof delay === 'number' ? `${delay}ms` : delay;
  }
  return null;
}

export const vHomeReveal: ObjectDirective<RevealEl> = {
  mounted(el, binding) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.classList.add('home-reveal');
    const delay = revealDelay(binding);
    if (delay) el.style.setProperty('--reveal-delay', delay);

    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-revealed');
      return;
    }

    const root = el.closest('.app-shell__main');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          el.classList.add('is-revealed');
          io.unobserve(el);
        });
      },
      {
        root: root instanceof Element ? root : null,
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    io.observe(el);
    el._homeRevealIo = io;
  },
  unmounted(el) {
    el._homeRevealIo?.disconnect();
  },
};
